import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import KuyumcuLeftSideNavbar from "./components/KuyumcuLeftSideNavbar";
import PremiumBackground from "./components/PremiumBackground";

import ProsetDataGrid from "./components/KuyumcuDataGrid";
import { getUserId } from "../../utils/getUserId";
import { usePermission } from "../../context/PermissionContext";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import {
  Box,
  Button,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";

import {
  FaCubes,
} from "react-icons/fa";

import { Edit, Delete } from "@mui/icons-material";
import axiosInstance from "../../api/axiosInstance";

import "./css/KuyumcuMainPage.css";
import "./css/KuyumcuStokPage.css";

import ProsetPopup from "./components/ProsetPopup.jsx";
import SilmeUyariPopup from "./components/SilmeUyariPopup";

const KuyumcuStokPage = () => {
  const navigate = useNavigate();
  const userId = getUserId();
  const { can, isLoading } = usePermission();

  // ====== STOK SAYFASI YETKİLERİ (DB'DEKİ KODLARA GÖRE DÜZENLE) ======
  const PERM_STOK_VIEW = "STOKLAR_VIEW";
  const PERM_STOK_CREATE = "STOKLAR_CREATE";
  const PERM_STOK_UPDATE = "STOKLAR_UPDATE";
  const PERM_STOK_DELETE = "STOKLAR_DELETE";
  const PERM_STOK_ISLEM_VIEW = "STOK_ISLEMLER_VIEW";


  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [silmePopupOpen, setSilmePopupOpen] = useState(false);
  const [silinecekStok, setSilinecekStok] = useState(null);

  const [stokIslemMap, setStokIslemMap] = useState({});

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [form, setForm] = useState({
    id: null,
    stokAdi: "",
    birim: "GRAM",
    miktar: 0,
    sabitMi: false,
    kullaniciId: userId,
  });

  /* ===========================================================
     EKRAN GENİŞLİĞİ & GİRİŞ KONTROL
  =========================================================== */
  useEffect(() => {
    if (!userId) {
      navigate("/login");
      return;
    }

    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [userId]);

  const formatNumberTR = (value, tamSayi = false) => {
    if (value === null || value === undefined) return "";

    return Number(value).toLocaleString("tr-TR", {
      minimumFractionDigits: tamSayi ? 0 : 2,
      maximumFractionDigits: tamSayi ? 0 : 2,
    });
  };

  /* ===========================================================
     STOK GETİR
  =========================================================== */
  const loadStoklar = async () => {
    if (!userId) return;

    try {
      const resp = await axiosInstance.get(`/stoklar?userId=${userId}`);
      const stokList = resp.data || [];
      setRows(stokList);

      // HER STOK İÇİN "İŞLEM VAR MI?" KONTROLÜ
      const map = {};

      await Promise.all(
        stokList.map(async (stok) => {
          try {
            const r = await axiosInstance.get(`/stok-islem?stokId=${stok.id}`);
            map[stok.id] = (r.data && r.data.length > 0);
          } catch {
            map[stok.id] = false;
          }
        })
      );

      setStokIslemMap(map);

    } catch (e) {
      console.error("Stok listesi alınamadı:", e);
    }
  };


  const rebuildStoklar = async () => {
    if (!userId) return;

    const ok = window.confirm(
      "Stoklar yeniden hesaplanacak.\nBu işlem stok işlemlerine göre miktarları sıfırlayıp tekrar hesaplar.\nDevam edilsin mi?"
    );

    if (!ok) return;

    try {
      await axiosInstance.post(`/stoklar/rebuild?userId=${userId}`);
      loadStoklar();
      alert("Stoklar başarıyla yeniden hesaplandı.");
    } catch (e) {
      console.error("Rebuild hatası:", e);
      alert("Stoklar yeniden hesaplanırken hata oluştu.");
    }
  };

  useEffect(() => {
    if (!userId) return;

    const init = async () => {
      try {
        await axiosInstance.post(`/stoklar/rebuild?userId=${userId}`);

        if (!isLoading && can(PERM_STOK_VIEW)) {
          await loadStoklar();
        } else {
          setRows([]); // yetkisi yoksa listeyi boş tut
        }
      } catch (e) {
        console.error("Stok init hatası:", e);
      }
    };


    init();
  }, [userId, isLoading, can]);

  /* ===========================================================
     KAYDET
  =========================================================== */
  const handleSave = async () => {
    if (!form.stokAdi) {
      alert("Stok adı zorunludur.");
      return;
    }

    try {
      if (editMode) {
        await axiosInstance.put(`/stoklar`, form);
      } else {
        await axiosInstance.post(`/stoklar`, form);
      }

      setOpen(false);
      setEditMode(false);
      loadStoklar();

      setForm({
        id: null,
        stokAdi: "",
        birim: "GRAM",
        miktar: 0,
        sabitMi: false,
        kullaniciId: userId,
      });
    } catch (e) {
      console.error("Stok kaydedilirken hata:", e);
      alert("Hata oluştu.");
    }
  };

  /* ===========================================================
     SİLME
  =========================================================== */

  const handleDeleteConfirmed = async () => {
    if (!silinecekStok) return;

    const { id, sabitMi } = silinecekStok;

    if (sabitMi) {
      alert("Bu stok sabittir ve silinemez.");
      return;
    }

    try {
      await axiosInstance.delete(`/stoklar/${id}`);
      loadStoklar();
    } catch (e) {
      console.error("Silme hatası:", e);
      alert("Silme sırasında hata oluştu.");
    } finally {
      setSilmePopupOpen(false);
      setSilinecekStok(null);
    }
  };


  /* ===========================================================
     RESPONSIVE KOLONLAR
  =========================================================== */
  const canUpdate = !isLoading && can(PERM_STOK_UPDATE);
  const canDelete = !isLoading && can(PERM_STOK_DELETE);
  const canGoIslem = !isLoading && can(PERM_STOK_ISLEM_VIEW);

  let columns = [];

    if (screenWidth < 480) {
      columns = [
        {
          field: "stokAdi",
          headerName: "Stok Adı",
          flex: 1,
          minWidth: 150,
        },

        {
          field: "miktar",
          headerName: "Miktar",
          flex: 1,
          minWidth: 80,
          renderCell: (p) =>
            formatNumberTR(p.row.miktar, p.row.sabitMi),

        },

        {
          field: "actions",
          headerName: "İşlemler",
          flex: 1,
          minWidth: 120,
          sortable: false,
          renderCell: (params) =>
            params.row.sabitMi ? (
              <div></div>
            ) : (
              <div className="stok-action-buttons">
                {canUpdate && (
                  <IconButton
                    className="stok-edit-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setEditMode(true);
                      setForm({
                        id: params.row.id,
                        stokAdi: params.row.stokAdi,
                        birim: "GRAM",
                        miktar: 0,
                        sabitMi: params.row.sabitMi,
                        kullaniciId: userId,
                      });
                      setOpen(true);
                    }}
                  >
                    <Edit />
                  </IconButton>
                )}


                {canDelete && !stokIslemMap[params.row.id] && (
                  <IconButton
                    className="stok-delete-btn"
                    style={{
                      visibility: stokIslemMap[params.row.id] ? "hidden" : "visible",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();

                      if (stokIslemMap[params.row.id]) return;

                      setSilinecekStok({
                        id: params.row.id,
                        sabitMi: params.row.sabitMi,
                      });
                      setSilmePopupOpen(true);
                    }}
                  >
                    <Delete />
                  </IconButton>
                )}

              </div>
            ),
        },
      ];
    } else {
      columns = [
        {
          field: "stokAdi",
          headerName: "Stok Adı",
          flex: 1,
          minWidth: 140,
        },

        {
          field: "miktar",
          headerName: "Miktar",
          flex: 0.6,
          minWidth: 90,
          renderCell: (p) =>
            formatNumberTR(p.row.miktar, p.row.sabitMi),

        },

        {
          field: "birim",
          headerName: "Birim",
          flex: 0.6,
          minWidth: 80,
        },

        {
          field: "actions",
          headerName: "İşlemler",
          flex: 1,
          minWidth: 140,
          sortable: false,
          renderCell: (params) =>
            params.row.sabitMi ? (
              <div></div>
            ) : (
              <div className="stok-action-buttons">

                {canUpdate  && (
                <IconButton
                  className="stok-edit-btn"
                  onClick={(e) => {
                    e.stopPropagation();

                    setEditMode(true);
                    setForm({
                      id: params.row.id,
                      stokAdi: params.row.stokAdi,
                      birim: "GRAM",
                      miktar: 0,
                      sabitMi: params.row.sabitMi,
                      kullaniciId: userId,
                    });
                    setOpen(true);
                  }}
                >
                  <Edit />
                </IconButton>
                )}


                {canDelete && !stokIslemMap[params.row.id] && (
                <Tooltip
                  title={
                    stokIslemMap[params.row.id]
                      ? "Stok işlemi bulunan stok silinemez!"
                      : "Sil"
                  }
                >
                <span>
                <IconButton
                  className="stok-delete-btn"
                  disabled={stokIslemMap[params.row.id]}
                  onClick={(e) => {
                    e.stopPropagation();

                    if (stokIslemMap[params.row.id]) return;

                    setSilinecekStok({
                      id: params.row.id,
                      sabitMi: params.row.sabitMi,
                    });
                    setSilmePopupOpen(true);
                  }}
                >
                  <Delete />
                </IconButton>

                </span>
                </Tooltip>

                )}


              </div>
            ),
        },
      ];
    }


  /* ===========================================================
     UI
  =========================================================== */
  return (
    <div className="main-container">
      <PremiumBackground />
      <KuyumcuLeftSideNavbar />

      <div className="content">
        <h1 style={{ color: "#b8860b", marginBottom: 20 }}><FaCubes/> Stoklar</h1>

        {!isLoading && can(PERM_STOK_CREATE) && (
          <Button
            variant="contained"
            startIcon={<AddCircleOutlineIcon />}
            sx={{
              background: "#b8860b",
              "&:hover": { background: "#d4a017" },
              borderRadius: "10px",
              marginBottom: 2,
              paddingX: 3,
              paddingY: 1,
              fontWeight: 600,
            }}
            onClick={() => {
              setEditMode(false);
              setForm({
                id: null,
                stokAdi: "",
                birim: "GRAM",
                miktar: 0,
                sabitMi: false,
                kullaniciId: userId,
              });
              setOpen(true);
            }}
          >
            Stok Ekle
          </Button>
        )}

          <ProsetDataGrid
            rows={rows}
            columns={columns}
            pageSize={8}
            onRowClick={(p) => navigate(`/kuyumcuStokIslem/${p.row.id}`)}
          />

        {/* POP-UP */}
        <ProsetPopup
          open={open}
          title={editMode ? "Stok Düzenle" : "Yeni Stok"}
          editMode={editMode}
          sabitMi={form.sabitMi}
          onSave={handleSave}
          onCancel={() => setOpen(false)}
          onDelete={() => {
            if (stokIslemMap[form.id]) {
              alert("Bu stok için işlem bulunmaktadır. Silinemez.");
              return;
            }

            setSilinecekStok({
              id: form.id,
              sabitMi: form.sabitMi,
            });
            setSilmePopupOpen(true);
          }}


        >
          <TextField
            fullWidth
            label="Stok Adı"
            margin="dense"
            value={form.stokAdi}
            onChange={(e) => setForm({ ...form, stokAdi: e.target.value })}
            disabled={form.sabitMi}
          />

          <TextField fullWidth margin="dense" label="Birim" value="GRAM" disabled />

          <TextField fullWidth margin="dense" label="Miktar" type="number" value={0} disabled />
        </ProsetPopup>

        <SilmeUyariPopup
          open={silmePopupOpen}
          message="Bu stoğu silmek istediğinize emin misiniz?"
          onCancel={() => {
            setSilmePopupOpen(false);
            setSilinecekStok(null);
          }}
          onConfirm={handleDeleteConfirmed}
        />

      </div>
    </div>
  );
};

export default KuyumcuStokPage;
